module.exports = "<div class=\"OT_dialog-centering\"><div class=\"OT_dialog-centering-child\"><div class=\"OT_root OT_dialog OT_dialog-plugin-upgraded\"><div class=\"OT_dialog-messages\"><div class=\"OT_dialog-messages-main\">Update Complete.</div><div class=\"OT_dialog-messages-minor\">The OpenTok plugin has been succesfully updated. Please reload your browser.</div></div><div class=\"OT_dialog-single-button\"><div class=\"OT_dialog-button OT_dialog-button-large OT_dialog-no-natural-margin\" role=\"OT_refresh\">Reload</div></div></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/html/updateComplete.html
// module id = 502
// module chunks = 0